import {
  Alert,
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Fade,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  TextField,
  Typography
} from '@mui/material';
import { Close } from 'mdi-material-ui';
import { forwardRef, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { apiService } from '../../api/axiosClient';
import { FileUploaderSingle } from '../../components/upload';
import DropzoneWrapper from '../../styles/react-dropzone';

const Transition = forwardRef((props, ref) => <Fade ref={ref} {...props} />)

const DialogCatalog = (props) => {
  const { show, setShow, setReload } = props
  const [loading, setLoading] = useState(false)
  const [icons, setIcons] = useState([]);
  const [files, setFiles] = useState([]);
  const defaultValues = {
    title: '',
    showorder: 0
  }
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ defaultValues })

  useEffect(() => {
    if(!show) {
      reset(defaultValues);
      setIcons([]);
      setFiles([]);
    }
  },[show])

  const onSubmit = async (data, e) => {
    setLoading(true)

    const [icon] = icons;
    const [file] = files;
    const formData = new FormData();

    formData.append('title', data.title);
    formData.append('showorder', data.showorder);
    formData.append('icon', icon);
    formData.append('file', file);

    try {
      const response = await apiService.postFormData('/catalog', formData);
      toast.success('등록 되었습니다.');
      setReload(reload => reload + 1);
    } catch (error) {
      console.error('Error creating catalog:', error);
    } finally {
      setLoading(false);
      setShow(false);
    }
  }

  return (
    <Card>
      <Dialog
        fullWidth
        open={show}
        maxWidth='md'
        scroll='body'
        onClose={() => setShow(false)}
        TransitionComponent={Transition}
      >
        <form onSubmit={handleSubmit(onSubmit)} id="catalogform">
          <DialogContent sx={{ pb: 3, px: { xs: 8, sm: 15 }, pt: { xs: 4, sm: 8 }, position: 'relative' }}>
            <IconButton
              size='small'
              onClick={() => setShow(false)}
              sx={{ position: 'absolute', right: '1rem', top: '1rem' }}
            >
              <Close />
            </IconButton>
            <Box sx={{ mb: 4, textAlign: 'center' }}>
              <Typography variant='h5' sx={{ mb: 3, lineHeight: '2rem' }}>
                Catalog 등록
              </Typography>
            </Box>

            <Grid container spacing={6}>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <Controller
                    name='title'
                    control={control}
                    rules={{ required: true }}
                    defaultValue=""
                    render={({ field: { value, onChange } }) => (
                      <TextField
                        value={value}
                        label='제목'
                        id='title'
                        onChange={onChange}
                        placeholder='제목을 입력해주세요'
                        error={Boolean(errors.title)}
                        aria-describedby='validation-async-title'
                        variant="standard"
                      />
                    )}
                  />
                  {errors.title && (
                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-title'>
                      필수
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>              

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <Controller
                    name='showorder'
                    control={control}
                    rules={{ required: true }}
                    defaultValue=""
                    render={({ field: { value, onChange } }) => (
                      <TextField
                        value={value}
                        label='순서'
                        id='showorder'
                        onChange={onChange}
                        placeholder='순서를 입력해주세요'
                        error={Boolean(errors.showorder)}
                        aria-describedby='validation-async-showorder'
                        variant="standard"
                      />
                    )}
                  />
                  {errors.showorder && (
                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-showorder'>
                      필수
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <DropzoneWrapper>
                  <Alert severity='info' sx={{mb:2}}> 카탈로그 표지 이미지를 업로드하세요 </Alert>
                  <FileUploaderSingle files={icons} setFiles={setIcons} update={false}/>

                  <Alert severity='warning' sx={{mt:2, mb:2}}> 카탈로그 pdf 파일를 업로드하세요 </Alert>
                  <FileUploaderSingle files={files} setFiles={setFiles} update={false}/>
                </DropzoneWrapper>
              </Grid>

            </Grid>
          </DialogContent>
        </form>

        <DialogActions sx={{ pb: { xs: 4, sm: 8 }, justifyContent: 'center' }}>
          <Button type="submit" form="catalogform" variant='contained'>
            {loading ? (
              <CircularProgress
                sx={{
                  color: 'common.white',
                  width: '20px !important',
                  height: '20px !important',
                  mr: theme => theme.spacing(2)
                }}
              />
            ) : null}
            등록
          </Button>
          <Button variant='outlined' color='secondary' onClick={() => setShow(false)}>
            취소
          </Button>
        </DialogActions>

      </Dialog>
    </Card>
  )
}

export default DialogCatalog